import axios from "axios";
import router from "@/router";
import {getToken,removeToken} from "@/utils/auth";
import { ElMessage } from 'element-plus'

const BASE_URL = process.env.NODE_HOST;

axios.defaults.timeout = 10000 * 30; // 超时时间设置
axios.defaults.withCredentials = true; // true允许跨域
axios.defaults.baseURL = BASE_URL;
// Content-Type 响应头
axios.defaults.headers.post["Content-Type"] = "application/x-www-form-urlencoded;charset=UTF-8";

// 请求拦截器
axios.interceptors.request.use(
    (config) => {
      // 获取 token
      const token = getToken();
      if (token) {
        // 在请求头中添加 AUTH-TOKEN
        config.headers['AUTH-TOKEN'] = token;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
);

// 响应拦截器
axios.interceptors.response.use(
  (response) => {
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    // 否则的话抛出错误
    if (response.status === 200) {
      return Promise.resolve(response);
    } else {
      return Promise.reject(response);
    }
  },
  // 服务器状态码不是2开头的的情况
  (error) => {
    if (error?.response?.status) {
      console.log("错误状态码: " + error?.response?.status)
      switch (error?.response?.status) {
        // 401: 未登录
        case 401:
          console.log("错误状态码: " + error.response.status);
          removeToken();
          ElMessage.warning({
            message: '登录失效，请重新登录！',
            duration: 3000
          });
          router.replace('/');
          break;
        case 403:
          // console.log('管理员权限已修改请重新登录')
          // 跳转登录页面，并将要浏览的页面fullPath传过去，登录成功后跳转需要访问的页面
          setTimeout(() => {
            router.replace({
              path: "/",
              query: {
                // redirect: router.currentRoute.fullPath
              },
            });
          }, 1000);
            removeToken();
          break;

        // 404请求不存在
        case 404:
          // console.log('请求页面飞到火星去了')
          break;
      }
      // return Promise.reject(error.response);
      return;
    }
  }
);

export function getBaseURL() {
  return BASE_URL;
}

/**
 * 封装get方法
 * @param url
 * @param data
 * @returns {Promise}
 */
/*export function get(url, params?: object) {
  return new Promise((resolve, reject) => {
    // axios.get(url, params).then(
    //   (response) => resolve(response.data),
    //   (error) => reject(error)
    // );
    axios.get(url, {
      params: params
    }).then(
        response => {
          if (response && response.data) {
            resolve(response.data);
          } else {
            // 接口返回空 不做处理
            // reject(response);
          }
        },
        error => reject(error)
    );
  });
}*/
export function get(url, params?: object) {
  return new Promise((resolve, reject) => {
    axios.get(url, {
      params: params
    })
        .then(response => {
          if (response && response.data) {
            resolve(response.data);
          }
          /*else {
            // 接口返回空 不做处理
            ElMessage.error({
              message: '服务请求失败！',
              duration: 3000
            });
            reject(new Error('Response data is empty'));
          }*/
        })
        .catch(error => {
          // 处理异常情况
          console.error('GET request failed:', error);
     /*     ElMessage.error({
            message: '服务请求失败！',
            duration: 3000
          });*/
          reject(error);
        });
  });
}


/**
 * 封装post请求
 * @param url
 * @param data
 * @returns {Promise}
 */
/*export function post(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, data).then(
        (response) => resolve(response.data),
        (error) => reject(error)
    );
  });
}*/
export function post(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.post(url, data)
        .then((response) => {
          if (response && response.data) {
            resolve(response.data);
          }
          /*else {
            ElMessage.error({
              message: '服务请求失败！',
              duration: 3000
            });
            reject(new Error('Response data is empty'));
          }*/
        })
        .catch((error) => {
          // 处理异常情况
          console.error('POST request failed:', error);
         /* ElMessage.error({
            message: '服务请求失败！',
            duration: 3000
          });*/
          reject(error);
        });
  });
}


/**
 * 封装delete请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function deletes(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.delete(url, data).then(
      (response) => resolve(response.data),
      (error) => reject(error)
    );
  });
}

/**
 * 封装put请求
 * @param url
 * @param data
 * @returns {Promise}
 */
export function put(url, data = {}) {
  return new Promise((resolve, reject) => {
    axios.put(url, data).then(
      (response) => resolve(response.data),
      (error) => reject(error)
    );
  });
}



/**
 * 文件上传(multipart格式) -- 用于制作人资料上传
 * @param url
 * @param parameter
 * @returns {*}
 */
export function uploadMultipartFile(url, params, picFile, songUrlFile, songPicFile) {
    const fd = new FormData();
    fd.append("picFile", picFile);
    fd.append("songUrlFile", songUrlFile);
    fd.append("songPicFile", songPicFile);
    delete params['picFile']
    delete params['songUrlFile']
    delete params['songPicFile']
    return axios.post(url, fd, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        timeout: 10000 * 30,
        params: params,
    })
}


/**
 * 文件上传(multipart格式) -- 用于单曲审核上传
 * @param url
 * @param parameter
 * @returns {*}
 */
export function songReviewUploadFile(url, params, urlFile, picFile) {
    const fd = new FormData();
    fd.append("urlFile", urlFile);
    fd.append("picFile", picFile);
    delete params['picFile']
    delete params['urlFile']
    return axios.post(url, fd, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        timeout: 10000 * 30,
        params: params,
    })
}
export function uploadFile(url, params, file) {
    const fd = new FormData();
    fd.append("file", file);
    return axios.post(url, fd, {
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        timeout: 10000 * 30,
        params: params,
    })
}

